import { reduxKey } from './constants';
export var BlockReasons;
(function (BlockReasons) {
    BlockReasons["DeviationBlocked"] = "deviation-blocked";
    BlockReasons["ArtistBlocked"] = "artist-blocked";
    BlockReasons["Age"] = "age";
    BlockReasons["StrictAge"] = "strict-age";
    BlockReasons["BlockedByArtist"] = "blocked-by-artist";
    BlockReasons["Antisocial"] = "antisocial";
})(BlockReasons || (BlockReasons = {}));
//# sourceMappingURL=types.js.map